var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgGulf = function SvgGulf(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1000 1000",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.2 657.398C120.2 657.398 120.2 733.298 196.1 733.298C272.1 733.298 272.1 657.398 348 657.398C424 657.398 424 733.298 499.9 733.298C575.9 733.298 575.9 657.398 651.8 657.398C727.8 657.398 727.8 733.298 803.7 733.298C879.6 733.298 879.7 657.398 955.6 657.398",
    strokeWidth: 29,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2 532.203C120.2 532.203 120.2 608.103 196.1 608.103C272.1 608.103 272.1 532.203 348 532.203C424 532.203 424 608.103 499.9 608.103C575.9 608.103 575.9 532.203 651.8 532.203C727.8 532.203 727.8 608.103 803.7 608.103C879.6 608.103 879.7 532.203 955.6 532.203",
    strokeWidth: 29,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2 407C120.2 407 120.2 482.9 196.1 482.9C272.1 482.9 272.1 407 348 407C424 407 424 482.9 499.9 482.9C575.9 482.9 575.9 407 651.8 407C727.8 407 727.8 482.9 803.7 482.9C879.6 482.9 879.7 407 955.6 407",
    strokeWidth: 29,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2 281.797C120.2 281.797 120.2 357.697 196.1 357.697C272.1 357.697 272.1 281.797 348 281.797C424 281.797 424 357.697 499.9 357.697C575.9 357.697 575.9 281.797 651.8 281.797C727.8 281.797 727.8 357.697 803.7 357.697C879.6 357.697 879.7 281.797 955.6 281.797",
    strokeWidth: 29,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgGulf);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "assets/icons/gulf.svg";